export const ROUTER_PATHS = {
	LOGIN: '/',
	LOGIN_EMAIL_CODE_VALIDATION: '/code-validation',

	CROSSROADS: '/cross-roads',
	ACCOUNT_WINDOWS_LOGIN_SUCCESSFUL: '/account-windows-login-successful',
	ERROR_404: '/error-404',

	LOGIN_SUCCESS_V3: '/nextgen-login-successful',
	LOGIN_SUCCESS_V2: '/login-successful',
	LOGIN_SUCCESS_TUNA: '/tuna-login-success',
	LOGIN_SUCCESS_MOBILE: '/vm-soundboard-login-success',
	LOGIN_SUCCESS_STORE: '/store-redirect',
	LOGIN_SUCCESS_TWITCH: '/twitch-success-connection',

	ACCOUNT_ERROR: '/account-activated-error',
	ACCOUNT: '/user-account',
	ACCOUNT_DELETED: '/goodbye',

	CONNECT_SUCCESS: '/connect-success',
	CONNECT_ERROR: '/connect-error',

	DESKTOP_DOWNLOAD: '/account-activated-success',
	MOBILE_DOWNLOAD_REDIRECT: '/redirect-mobile-download',

	CHECKOUT_V2: '/checkout',
	CHECKOUT_V3: '/flagship-checkout',
	CHECKOUT_PAYMENT_CHECK: '/payment-check',
	CHECKOUT_PADDLE_PAYMENT_CHECK: '/paddle-payment-check',
	CHECKOUT_PAYMENT_SUCCESS: '/payment-success',
	CHECKOUT_PAYMENT_ERROR: '/payment-error',

	AUTHORIZE: '/authorize',

	VOICEMOD_CONTROLLER_APP: '/voicemod-controller-app',
	VOICEMOD_SOUNDBOARD_APP: '/voicemod-soundboard-app',

	REDIRECT_COUPON: '/coupon-login-success',
	REDIRECT_REPORT_MODERATOR: '/report-moderator-login-success',

	// deprecated
	TTSING: '/ttsing-login-success',
	BEG: '/beg',
	BEG_GIFTING: '/begalicense',
	GIFT: '/gifting',
	GIFT_SUCCESS: '/gifting/success',
	VM_KEY: '/vm-key',
	VM_KEY_COMPLETE_ORDER: '/complete-order',
	VM_KEY_ORDER_SUCCESS: '/order-success',
	ADDRESS_FORM: '/address-form',
	VOICEROOM: '/voice-room-login-success',
	BROADCAST: '/broadcast-login-success',
	SHARE_SUCCESS: '/share-success',
	BETA_PROGRAM_ACCEPTED: '/beta-program-accepted',
	AI_BETA_PROGRAM_ACCEPTED: '/ai-beta-program-accepted',
	VMGO: '/vm-go-login-success',
};
